import { ReactNode, HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface PremiumCardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /** "default" = subtle card. "glow" = primary accent glow. "muted" = lower emphasis. */
  variant?: "default" | "glow" | "muted";
  padded?: boolean;
}

export default function PremiumCard({
  children,
  variant = "default",
  padded = true,
  className,
  ...rest
}: PremiumCardProps) {
  return (
    <div
      {...rest}
      className={cn(
        "relative rounded-2xl border backdrop-blur-xl transition-colors",
        padded && "p-4 sm:p-5",
        variant === "default" &&
          "bg-card/80 border-border/50 hover:border-border/70",
        variant === "glow" &&
          "bg-card/85 border-primary/30 shadow-[0_0_30px_hsl(var(--primary)/0.18)]",
        variant === "muted" && "bg-card/40 border-border/40",
        className,
      )}
    >
      {children}
    </div>
  );
}